import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

// pipe to add some string properties to order by them after check
@Pipe({ name: 'sortByStringCi' })
export class SortByStringCiPipe implements PipeTransform {
	
	transform(value: any[], column: string, order = ''): any[] {
		if (!value || !column || column === '' || order === '') { return value; } // no array
		if (value.length <= 1) { return value; } // array with only one item
		return _.orderBy(value, [value => value.name.toLowerCase()], [order]);
			

	}
}